var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlchemy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1008,
    height: 861,
    viewBox: "0 0 1008 861",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M838.577 551.198L519.602 8.87627C518.058 6.19837 515.821 3.96769 513.118 2.40933C510.415 0.850961 507.34 0.0200199 504.206 0.000357256C501.071 -0.0193054 497.987 0.772998 495.264 2.29733C492.54 3.82165 490.276 6.0241 488.697 8.68241L393.167 171.185C390.038 176.504 388.392 182.538 388.392 188.681C388.392 194.823 390.038 200.857 393.167 206.177L601.159 559.97C604.291 565.294 608.797 569.715 614.222 572.786C619.648 575.858 625.801 577.472 632.064 577.466H823.124C826.252 577.456 829.323 576.642 832.029 575.103C834.736 573.564 836.983 571.354 838.548 568.695C840.112 566.036 840.937 563.021 840.942 559.95C840.948 556.88 840.132 553.862 838.577 551.198Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45963 834.635L321.434 292.314C323 289.657 325.25 287.451 327.958 285.918C330.665 284.384 333.736 283.577 336.862 283.577C339.988 283.577 343.06 284.384 345.768 285.918C348.476 287.451 350.725 289.657 352.29 292.314L447.87 454.671C450.998 459.999 452.644 466.041 452.644 472.191C452.644 478.341 450.998 484.383 447.87 489.711L239.876 843.504C236.757 848.828 232.261 853.25 226.843 856.322C221.425 859.394 215.277 861.007 209.02 861H17.9122C14.764 861.015 11.668 860.212 8.93874 858.672C6.20948 857.131 3.94471 854.908 2.37465 852.23C0.804592 849.551 -0.0147809 846.512 0.000201848 843.421C0.0151846 840.331 0.863664 837.299 2.45963 834.635Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M352.245 860.884H990.194C993.323 860.881 996.398 860.069 999.106 858.53C1001.81 856.991 1004.06 854.779 1005.62 852.117C1007.18 849.454 1008 846.435 1008 843.363C1008 840.291 1007.17 837.274 1005.6 834.616L910.167 672.162C907.035 666.837 902.53 662.417 897.105 659.345C891.679 656.274 885.525 654.66 879.262 654.666H463.276C457.013 654.66 450.859 656.274 445.434 659.345C440.008 662.417 435.502 666.837 432.371 672.162L336.842 834.616C335.273 837.274 334.444 840.291 334.44 843.363C334.435 846.435 335.254 849.454 336.815 852.117C338.377 854.779 340.625 856.991 343.334 858.53C346.042 860.069 349.115 860.881 352.245 860.884Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 504,
    y1: 64,
    x2: 415.044,
    y2: 861.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#363FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5533FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 504,
    y1: 64,
    x2: 415.044,
    y2: 861.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#363FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5533FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 504,
    y1: 64,
    x2: 415.044,
    y2: 861.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#363FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5533FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlchemy);
export default __webpack_public_path__ + "static/media/alchemy.3d2eb2ca65603ba7b755cde628e719df.svg";
export { ForwardRef as ReactComponent };